module.exports = __webpack_public_path__ + "img/shixny.a1afcfff.png";